export default __webpack_public_path__ + "static/media/sens-train.99b485bf.png";